module.exports = __webpack_public_path__ + "static/img/shl_introduce_tab_organize_selected.58c92d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_introduce_tab_organize_selected.png
// module id = Gf19
// module chunks = 5